<template>
<div v-if="trainer">
  <component :is="trainer.component" :trainer="trainer"></component>
</div>
</template>

<script>
import TrainerMethods from '../../classes/trainer_methods'
import { mapGetters, mapMutations } from 'vuex'
export default {
  provide() {
    return {
      TrainerMethods
    }
  },
  name: "trainer",
  components: {
    'Memo': require('./memo/Memo').default,
    'shulte': require('./shulte/Shulte').default,
    'mnemo': require('./mnemo/start').default,
    'gorbov': require('./gorbov/start').default,
    'texts': require('./texts/start').default,
    'spritz': require('./spritz/start').default,
    'bee': require('./bee/start').default,
    'speedtest': require('./speedtest/start').default,
    'strup': require('./strup/start').default,
    'alphabet': require('./alphabet/start').default,
    'metronom': require('./metronom/start').default,
    'wedge': require('./wedge/start').default,
  },
  computed: {
		...mapGetters({
			trainerByName: 'train/trainerByName'
		}),
    trainer() {      
			return this.trainerByName(this.$route.params.component)
    }
  },
  // для старых тренажеров
	methods: {
		...mapMutations({
			setCurrentTrainer: 'setCurrentTrainer'
		})
	},
  created() {
    if (this.trainer) {
      this.setCurrentTrainer(this.trainer)
    }
  },
  watch: {
    trainer() {
      if (this.trainer) {
        this.setCurrentTrainer(this.trainer)
      }
    }
  }
}
</script>
